export const PRICING_ADD_PRICING = "PRICING_ADD_PRICING";
export const PRICING_GET_PRICING = "PRICING_GET_PRICING";
export const PRICING_UPDATE_PRICING = "PRICING_UPDATE_PRICING";
export const PRICING_DELETE_PRICING = "PRICING_DELETE_PRICING";